import { render } from "./_base-fieldset-tabs.vue?vue&type=template&id=0e1e101d"
import script from "./_base-fieldset-tabs.vue?vue&type=script&lang=js"
export * from "./_base-fieldset-tabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__